import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mode-toggle"
export default class extends Controller {
  static targets = ["button", "title", "description", "groupInfo", "caption"]

  static values = {
    default: String
  }

  connect() {
    this.switchTo(this.defaultValue || "individual")
  }

  select(event) {
    const mode = event.currentTarget.dataset.mode
    this.switchTo(mode)
  }

  switchTo(mode) {
    // Active Button
    this.buttonTargets.forEach(btn => {
      btn.classList.toggle(
          "active",
          btn.dataset.mode === mode
      )
    })

    document
        .querySelectorAll('input[name="mode"]')
        .forEach(input => input.value = mode)

    document
        .querySelectorAll(".member-checkbox")
        .forEach(cb => {
          cb.setAttribute("form", "clock-in-form")
          cb.setAttribute("form", "clock-out-form")
        })

    if (mode === "individual") {
      this.titleTarget.textContent = "勤怠打刻（個人）"
      this.descriptionTarget.textContent = "スマホから出勤・退勤を登録します（ログイン中の職員）"
      this.captionTarget.textContent = "個人モード：ログイン中の職員だけを打刻します。"

      this.groupInfoTarget.style.display = "none"
    } else {
      this.titleTarget.textContent = "勤怠打刻（班一括）"
      this.descriptionTarget.textContent = "作業班の中から選択した班員を一括で打刻します。"
      this.captionTarget.textContent = "第1作業班 の中からチェックした班員を一括で打刻します。"

      this.groupInfoTarget.style.display = "block"
    }
  }
}
